import { render, staticRenderFns } from "./Learning_component.vue?vue&type=template&id=496aef98&"
import script from "./Learning_component.vue?vue&type=script&lang=js&"
export * from "./Learning_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports